module.exports = __webpack_public_path__ + "static/assets/499a035b3b3b283ca4257fd26c725491.png";